module.exports = __webpack_public_path__ + "img/leihs.cb679ad7.png";